import { render, staticRenderFns } from "./Wmds.vue?vue&type=template&id=0c072b2a&"
import script from "./Wmds.vue?vue&type=script&lang=js&"
export * from "./Wmds.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports